import { Panel, severityClasses } from "../Panel"
import type { EconomicItem } from "../dashboard-types"

export function EconomicPressure({ items, demo }: { items: EconomicItem[]; demo?: boolean }) {
  return (
    <Panel title="Economic Pressure" demo={demo} count={items.length}>
      <div>
        {items.map((it, i) => {
          const sv = severityClasses(it.severity)
          return (
            <div key={it.id} className="px-3 py-2 border-b border-[color:var(--border)] last:border-b-0 flex items-center gap-3">
              <div className={`w-7 h-7 rounded flex items-center justify-center text-xs font-bold tabular-nums ${sv.bg} ${sv.text}`}>
                {i + 1}
              </div>
              <div className="flex-1 text-sm text-[color:var(--text)] truncate">{it.title}</div>
              <div className="text-[10px] text-[color:var(--text-muted)] tabular-nums">{it.signals} sig</div>
            </div>
          )
        })}
      </div>
    </Panel>
  )
}
